import { AuthContext } from '../context'
import { useContext } from 'react'
import { LogIn } from './Login'

export const AuthWrapper = ({ children }) => {
  const { currentUser } = useContext(AuthContext)

  return currentUser ? children : <LogIn />
}
